export default __webpack_public_path__ + "static/media/logotipo-chungungo-flor.71f19217.svg";